import mitt, { Emitter, EventType } from 'mitt'
import { globalEvents } from './events'

const emitter: Emitter = mitt()

/**
 * @description Lắng nghe sự kiện
 * @param eventName Tên sự kiện
 * @param callback Callback khi có sự kiện
 * @author PHNam
 */
const on = (eventName: EventType, callback: any) => {
  emitter.on(eventName, callback)
}

/**
 * @description Hủy lắng nghe sự kiện
 * @param eventName Tên sự kiện
 * @param callback Callback khi có sự kiện
 * @author PHNam
 */
const off = (eventName: EventType, callback: any) => {
  emitter.off(eventName, callback)
}

/**
 * @description Publish một sự kiện
 * @param eventName Tên sự kiện
 * @param event Event cần publish
 * @author PHNam
 */
const emit = (eventName: EventType, event?: any) => {
  emitter.emit(eventName, event)
}

export { on, off, emit, globalEvents }
